<template>
    <div>
  
    </div>
</template>

<script>
export default {
    name: 'mobile_head',
    data() {
        return {
        }
    },
}
</script>

<style scoped>

</style>
